export default __webpack_public_path__ + "static/media/apple_store.b5a9644a.svg";